<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-download"></i> 入库记录</span>
      </div>

      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="固定物资" name="fixed">
          <FixedMaterialTab />
        </el-tab-pane>
        <el-tab-pane label="日常消耗" name="daily">
          <DailyMaterialTab />
        </el-tab-pane>
        <el-tab-pane label="低值易耗" name="consumables">
          <ConsumableMaterialTab />
        </el-tab-pane>
        <el-tab-pane label="食材物资" name="food">
          <FoodMaterialTab />
        </el-tab-pane>
         <el-tab-pane label="食材物资详情" name="fooddetail">
          <FoodDetailMoreTab />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import FixedMaterialTab from "./fixedTab.vue";
import DailyMaterialTab from "./dailyTab.vue";
import ConsumableMaterialTab from "./consumableTab.vue";
import FoodMaterialTab from "./foodTab.vue";
import FoodDetailMoreTab from "./fooddetail.vue";

export default {
  name: "InStockRecord",
  components: {
    FixedMaterialTab,
    DailyMaterialTab,
    ConsumableMaterialTab,
    FoodMaterialTab,
    FoodDetailMoreTab
  },
  data() {
    return {
      activeTab: "fixed", // 默认激活“固定物资”Tab
    };
  },
  methods: {
    handleTabChange() {
      // 可根据需要添加逻辑
    },
  },
};
</script>

<style scoped>
.app-container {
    
  }
.el-card {
  margin-bottom: 20px;
}
</style>

